export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/9efedd6f8d84b8cf11b1862201b47d04.svg";